<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div class="button-container">
          <el-button
            type="danger"
            icon="el-icon-folder-delete"
            @click="handleOfflineProduct"
          >{{ $t('button.offlineProduct') }}</el-button>
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <div
      v-loading="isLoading"
    >
      <template v-for="table in tables">
        <div
          v-if="productsByType[table.id].length > 0"
          :key="table.id"
          class="pb-4"
        >
          <div class="font-size-14 mb-2 font-weight-bold">{{ table.label }}</div>
          <el-table
            :data="productsByType[table.id]"
            border
            stripe
          >
            <el-table-column
              v-for="column in table.columns"
              :key="column.type"
              :prop="column.type"
              :label="column.title || $t(`table.${column.type}`)"
              v-bind="column.custom"
            >
              <template slot-scope="{ row }">
                <template v-if="column.type === 'target_id' || column.type === 'location'">
                  <template v-for="(id, index) in row[column.type].split(',')">
                    <el-tag
                      v-if="id !== ''"
                      :key="`${id}-${index}`"
                      effect="plain"
                    >{{ id }}</el-tag>
                  </template>
                </template>
                <template v-else>
                  {{ row[column.type] }}
                </template>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('table.action')"
              fixed="right"
              align="center"
              width="80"
            >
              <template #default="{ row }">
                <div class="button-group">
                  <el-button
                    size="mini"
                    type="warning"
                    icon="el-icon-edit"
                    circle
                    @click="handleUpdate(row)"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <offline-product-dialog
      :is-open="isOfflineProductDialogOpen"
      @close="isOfflineProductDialogOpen = false"
    />
  </sticky-header-layout>
</template>

<script>
import OfflineProductDialog from './components/OfflineProductDialog.vue'

import useTablePaging from '../../../mixins/useTablePaging'
import DisplayHardcodeService from '../../../api/display-hardcode'

import { hardcodeLists as tables } from '../../../const/product'

export default {
  name: 'HardcodeProductList',
  components: {
    OfflineProductDialog,
  },
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      isOfflineProductDialogOpen: false,
      tables,
    }
  },
  computed: {
    productsByType() {
      return {
        productPrice: this.list.filter(data => data.type === 1),
        storePrice: this.list.filter(data => data.type === 2),
        forceOnline: this.list.filter(data => data.type === 4),
      }
    },
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await DisplayHardcodeService.getList({
          page: this.listQuery.page,
          size: this.listQuery.size,
        })
        const { data: newList, pagination } = response
        this.list = newList.map((hardcode) => {
          if (Array.isArray(hardcode.location)) {
            hardcode.location = hardcode.location.join(',')
          }
          if (Array.isArray(hardcode.target_id)) {
            hardcode.target_id = hardcode.target_id.join(',')
          }
          return hardcode
        })
        this.listQuery.total = parseInt(pagination.total_items, 0)
      } finally {
        this.isLoading = false
      }
    },
    handleUpdate(row) {
      this.$router.push({ path: `/product/hardcode/edit/${row.id}` })
    },
    handleCreate() {
      this.$router.push({ path: '/product/hardcode/create' })
    },
    handleOfflineProduct() {
      this.isOfflineProductDialogOpen = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.shop-category-list {
  &__search {
    width: 260px;
  }
}
</style>
